export default __webpack_public_path__ + "static/media/cat4.5ded2788.png";